import React, { useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { useParams } from 'react-router-dom';
import getBaseUrl from '../helpers/utility';


const EffectifBrigade = () => {
  const { id } = useParams();
  const baseUrl = getBaseUrl();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const [personnel, setPersonnel] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/brigade/api/${id}/effectif`);
        setData(response.data.data);

        const personnelId = response.data.data?.brigade?.personnelId;

        if (personnelId && !isNaN(personnelId)) {
          try {
            const responsePersonnel = await axios.get(`/personnel/show/${personnelId}`);
            if (responsePersonnel?.data) {
              setPersonnel(responsePersonnel.data);
            }
          } catch (err) {
            console.warn("⚠️ Aucun personnel trouvé pour cette brigade :", err.message);
            // Optionnel : tu peux afficher un toast si tu veux prévenir l'utilisateur
            // toast.warn("Aucun chef de brigade n'est encore défini.");
          }
        } else {
          console.log("ℹ️ Aucun personnelId trouvé pour cette brigade.");
        }

        /* if (response.data.data?.brigade?.personnelId) {          
          const responsePersonnel = await axios.get(`${baseUrl}/personnel/show/${response.data.data.brigade.personnelId}`);
          responsePersonnel && setPersonnel(responsePersonnel.data);
        } */
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return <p className="container mt-5 pt-5">Chargement...</p>;
  }
  if (error) {
    return (
      <p style={{ fontSize: '40px', fontFamily: 'impact' }} className=" text-bold bg-danger container mt-5 p-2">
        {error}
      </p>
    );
  }
  console.log(personnel);
  return (
    <div className="jumbotron">
      <div className="row ">
        <div className="col d-flex justify-content-center ">
          <div className="col-md-8 ">
            <img width="100%" height="500px" className="personnelImage" src={`${baseUrl}/images/brigades/${data.brigade?.filename}`} alt={data.brigade?.filename} />
          </div>
          <div className="col-md-4">
            <div className="col-md-6">{personnel ? <img className="card-img-top" src={`${baseUrl}/images/personnels/${personnel?.filename}`} alt={personnel.filename} /> : ''}</div>
            <h3 className="text-danger">
              <h3>{data?.brigadeName}</h3>
            </h3>
            <h3 className="text-primary">
              <ul>
                {data.brigade?.bataillons?.map((bataillon) => (
                  <li key={bataillon.id}> <i className='fa fa-location-arrow' ></i> {bataillon.name}</li>
                ))}
              </ul>
            </h3>
            <p>
              CHEF BRCA :<h3 className="text-warning">{(personnel && personnel.nomprenom) || ''}</h3>
            </p>
            <p>TPH : {(personnel && personnel.telephone) || ''}</p>

            <p>W/A : {(personnel && personnel.whatsapp) || ''}</p>
            <p>REF NOMINATION :{(personnel && personnel.decisionaffectation) || ''}</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">REF. Implantation :{data.brigade.reference}</div>
      </div>
      <hr />
      <div className="container">
        <div className="col">
          <div clas="row">
            <h2>EFFECTIF.</h2>
            {data.bataillons.map((bataillon, index) => (
              <div key={index}>
                <h3 className="bg-primary">{bataillon.bataillonName}.</h3>
                <table className="table table-striped">
                  <thead className="thead-dark">
                    <tr>
                      <th>Observation</th>
                      <th>OFFICIER</th>
                      <th>SOUS-OFF</th>
                      <th>ADL</th>
                      <th>PDL</th>
                      <th>TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Nombres</td>
                      <td>{bataillon.observations.OFF}</td>
                      <td>{bataillon.observations['S-OFF']}</td>
                      <td>{bataillon.observations.ADL}</td>
                      <td>{bataillon.observations.PDL}</td>
                      <td>{bataillon.observations.TOTAL}</td>
                    </tr>
                  </tbody>
                </table>

                <table className="table table-bordered table-dark">
                  <thead>
                    <tr>
                      <th>Compagnie</th>
                      <th>OFF</th>
                      <th>S-OFF</th>
                      <th>ADL</th>
                      <th>PDL</th>
                      <th>TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bataillon.compagnies.map((compagnie, compIndex) => (
                      <tr key={compIndex}>
                        <td>{compagnie.name}</td>
                        <td>{compagnie.OFF}</td>
                        <td>{compagnie['S-OFF']}</td>
                        <td>{compagnie.ADL}</td>
                        <td>{compagnie.PDL}</td>
                        <td>{compagnie.TOTAL}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EffectifBrigade;
